import { REDUX_ACTIONS, GAME_ID } from 'a/storybox/data/constants';

const initState = {
  wrongCount: 0,
  character: undefined,
  setting: undefined,
  solutions: [],
  repeatOnboarding: false,
};

const storyReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }
  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
    case REDUX_ACTIONS.START_STORY:
      return initState;

    case REDUX_ACTIONS.STORY_CHOICE_SELECTION:
      return {
        ...state,
        [payload.type]: payload.index,
      };

    case REDUX_ACTIONS.SHUFFLED_SOLUTIONS:
      return {
        ...state,
        solutions: payload.solutions,
      };

    case REDUX_ACTIONS.ONBOARDING_OFF:
      return {
        ...state,
        repeatOnboarding: false,
      };

    case REDUX_ACTIONS.ONBOARDING_ON:
      return {
        ...state,
        repeatOnboarding: true,
      };

    case REDUX_ACTIONS.INCREMENT_WRONG_COUNT:
      return {
        ...state,
        wrongCount: state.wrongCount + 1,
      };

    default:
      return state;
  }
};

export default storyReducer;
